import { useRouteError } from "react-router-dom";

import styles from './Error.module.css';

export const Error = () => {
    
    const error = useRouteError();
    console.error(error);

    return (
        <>
            <div className={ styles.dataContainer }>
                <div className={ styles.textContainer }>
                    <div className={ styles.headText }>¡Oops!</div>
                    <div className={ styles.mainText }>Al parecer nuestro sistema se enfermó, lo </div>
                    <div className={ styles.mainText }>atenderemos lo más pronto posible.</div>
                    {/* <div className={ styles.msgText }>{error.statusText || error.message}</div> */}
                </div>
                <div className={ styles.navbarLogo } />
            </div>

            <div className={styles.pacienteImgContainer}>
                <div className={styles.pacienteImg}></div>
            </div>

            <div className={ styles.waveWrap }>
                <div className={ styles.wave }></div>
            </div>
        </>
    )
}
